import { chunk } from '@belong/common';
import { Carousel } from '@belong/ui';
import type { ReviewModel } from 'src/api/models';
import { TestimonialReviewItem } from './components/testimonial-review-item/testimonial-review-item';

type Props = {
  reviews: ReviewModel[];
};

export function TestimonialReviews({ reviews }: Props) {
  const mobileTestimonialReviewSlides = chunk(reviews, 1);
  const desktopTestimonialReviewSlides = chunk(reviews, 3);

  return (
    <>
      <div className="contents lg:hidden">
        <Carousel arrowsOnDots>
          {mobileTestimonialReviewSlides.map(
            (mobileTestimonialReviewSlide, index) => {
              return (
                <div
                  className="mr-lg flex min-w-full justify-center last:mr-0"
                  key={index}
                >
                  {mobileTestimonialReviewSlide.map((review, index) => {
                    return (
                      <TestimonialReviewItem key={index} review={review} />
                    );
                  })}
                </div>
              );
            },
          )}
        </Carousel>
      </div>
      <div className="hidden lg:contents">
        <Carousel>
          {desktopTestimonialReviewSlides.map(
            (desktopTestimonialReviewSlide, index) => {
              return (
                <div
                  className="mr-lg flex min-w-full justify-center last:mr-0"
                  key={index}
                >
                  {desktopTestimonialReviewSlide.map((review) => {
                    return (
                      <TestimonialReviewItem key={review.id} review={review} />
                    );
                  })}
                </div>
              );
            },
          )}
        </Carousel>
      </div>
    </>
  );
}
